<template>
  <router-link :class="{small}" class="interactive-item d-inline-block my-1 my-md-2" :to="name ? {name, params} : null" v-if="name" :data-selected="routeSelected">
    <div class="interactive-label text-left" :data-active="active" :data-selected="routeSelected">
        <span class="text-sans">
          <small v-if="index !== undefined" class="d-inline-block red--text">{{ computedIndex }}</small>
          {{ label }}
        </span>
        <span class="text-script">{{ labelOver ? labelOver : label }}</span>
    </div>
  </router-link>
  <a :class="{small}" class="d-inline-block my-1 my-md-2" v-else :href="href" target="_blank">
    <div class="interactive-label text-left" :data-active="active">
        <span class="text-sans">
          <small v-if="index !== undefined" class="d-inline-block red--text">{{ computedIndex }}</small>
          {{ label }}
        </span>
        <span class="text-script">{{ labelOver ? labelOver : label }}</span>
    </div>
  </a>
</template>

<script>

// import isEqual from 'lodash/isEqual'

export default {
  name: 'InteractiveLabel',
  props: {
    label: {
      type: String,
      required: true
    },
    labelOver: {
      type: String,
      required: false
    },
    name: {
      type: String,
      required: false
    },
    href: {
      type: String,
      required: false
    },
    params: {
      type: Object,
      required: false
    },
    index: {
      type: Number,
      required: false
    },
    small: {
      type: Boolean,
      required: false,
      default: false
    },
    active: {
      type: Boolean,
      required: false,
      active: true
    }
  },
  computed: {
    computedIndex () {
      return this.index < 10 ? `0${this.index}` : this.index
    },
    routeSelected () {
      return this.$route.name === this.name && (this.$route.params && this.$route.params.slug) === (this.params && this.params.slug)
    }
  }
}
</script>

<style lang="scss" scoped>
.small {
  font-size: 12px;
}

.interactive-item {
  &[data-selected] {
    pointer-events: none;
  }
}

.interactive-label {
  position: relative;
  opacity: 0.2;
  transition: opacity 1s $ease-out-expo;

  &[data-active] {
    opacity: 1;
  }

  &:hover,
  &[data-selected] {

    @include breakpoint(sm-and-down) {
      span:nth-child(2) {
        transform: translate(-2px, -50%) !important;
      }
    }

    @include breakpoint(md-and-up) {
      span:nth-child(2) {
        transform: translate(3rem, -50%) !important;
      }
    }

    span {
      &:nth-child(1) {
        opacity: 0.05;
      }

      &:nth-child(2) {
        // transform: translate(-50%, -50%);
        opacity: 1;
      }
    }

  }
}

small {
  position: relative;
  font-size: 0.55rem;
  transform: translate(-2px, calc(50% + 5px));
  display: inline-block;
  font-weight: 500;
  font-family: $heading-font-family;

  @include breakpoint(md-and-up) {
    font-size: 0.9rem;
    transform: translate(-8px, calc(50% + 5px));
  }
}

span {
  white-space: nowrap;

  &:nth-child(1) {
    position: relative;
    font-size: 1.85rem;
    transition: opacity 1s $ease-out-expo;
    line-height: 1;

    @include breakpoint(md-and-up) {
      font-size: 4rem;
    }

    .small & {
      font-size: 1.35rem;
      @include breakpoint(md-and-up) {
        font-size: 2rem;
      }
    }
  }

  &:nth-child(2) {
    pointer-events: none;
    position: absolute;
    font-size: 1rem;
    right: 0;
    top: 50%;
    left: 1.5rem;
    transform: translate(0%, -40%);
    opacity: 0;
    transition: all 1s $ease-out-expo;
    color: map-deep-get($colors, 'red', 'base');

    @include breakpoint(md-and-up) {
      font-size: 2rem;
      left: 0;
      transform: translate(3rem, -40%);
    }

    .small & {
      font-size: 0.8rem;
      @include breakpoint(md-and-up) {
        font-size: 1.15rem;
      }
    }
  }
}

</style>
